import React, { useState } from 'react'

function NavItem({name, handler, index}) {

    const [hoverText, setHoverText] = useState(false)

    return (
        <React.Fragment>
            <div>
                <p
                    className="title has-text-weight-bold is-size-5"
                    style={{ color: "white", cursor: "pointer" }}
                    onMouseEnter={() => setHoverText(true)}
                    onMouseLeave={() => setHoverText(false)}
                    onClick={() => {handler(index)}}
                >
                    {
                        hoverText ? (
                            <span className="glowText">{name}</span>
                        ) : (
                            <span>{name}</span>
                        )
                    }
                </p>
            </div>
        </React.Fragment>
    )
}

export default NavItem
